import { Base } from "../../framework/base";
import { IdTitleNode, IIdTitleNode } from "../common/idTitleNode";
import { IRiskTemplateEditItem, RiskTemplateEditItem } from "./riskTemplateEditItem";

export interface IRiskTemplateNew {
    systemRiskTemplates: IRiskTemplateEditItem[];
    companyRiskTemplates: IRiskTemplateEditItem[];
    systemRiskCategories: IIdTitleNode[];
    companyRiskCategories: IIdTitleNode[];
}

export class RiskTemplateNew implements IRiskTemplateNew {
    systemRiskTemplates: RiskTemplateEditItem[];
    companyRiskTemplates: RiskTemplateEditItem[];
    systemRiskCategories: IdTitleNode[];
    companyRiskCategories: IdTitleNode[];

    constructor();
    constructor(obj: IRiskTemplateNew);
    constructor(obj?: any) {
        this.systemRiskTemplates = Base.getTypedArray(obj?.systemRiskTemplates, RiskTemplateEditItem);
        this.companyRiskTemplates = Base.getTypedArray(obj?.companyRiskTemplates, RiskTemplateEditItem);
        this.systemRiskCategories = Base.getTypedArray(obj?.systemRiskCategories, IdTitleNode);
        this.companyRiskCategories = Base.getTypedArray(obj?.companyRiskCategories, IdTitleNode);
    }
}